<script>

import { Overlay } from '../../'

export default {
    name: 'EaseOfMovement',
    mixins: [Overlay],
    methods: {
        meta_info() {
            return {
                author: 'StdSquad', version: '1.0.0',
                desc: 'Ease of Movement - Shows relationship between price change and volume',
                preset: {
                    name: 'Ease of Movement $length',
                    side: 'offchart',
                    settings: {
                        lineWidth: 1.5,
                        color: '#ff9800'
                    }
                }
            }
        },
        use_for() { return ['EaseOfMovement'] },
        calc() {
            return {
                props: {
                    length: { def: 14, text: 'Length' }
                },
                conf: { renderer: 'Spline' },
                update: `
                    let midpoint = (high[0] + low[0]) / 2
                    let previous = (high[1] + low[1]) / 2
                    let raw = ts(vol[0] ? (midpoint - previous) * (high[0] - low[0]) * 100000000 / vol[0] : 0)
                    return sma(raw, length)[0]
                `
            }
        }
    }
}
</script>
